import { BankUrlMethodParamEnum, BankUrlSceneParamEnum, IBankLoginSceneParams, generateMethodId, saveMethodDataById } from './bankLoginHelpers';
import { ButtonAction, ButtonType } from './getButtonData';
import { addDialogue } from './sessionUtils';
import { getTrans, redirectionTo, saveRecoveryContext } from './tools';
import { mergeQueryToUrl, parseUrlToObject } from './url-util';
import { bridgeCallFunc } from './instantLoaded/tools';
import { initStore, modalStore } from '@/stores';

const chatbotSkipFlag = 'chatbotSkipFlag=true';
const ID_NON_LIVE_LOGIN_PAGE = `https://app-uat1.uat.seabank.co.id/app/me/chatbot?fromChatbot=true&${chatbotSkipFlag}`;
const ID_LIVE_LOGIN_PAGE = `https://app.seabank.co.id/app/me/chatbot?fromChatbot=true&${chatbotSkipFlag}`;
const ID_NON_LIVE_WEBFORM
  = 'https://cs.uat.seabank.co.id/portal/webform/b9c9ba0744d44b57a8b58d57c0c3f5d2?entryPoint=141';
const ID_LIVE_WEBFORM = 'https://cs.seabank.co.id/portal/webform/ba662495821247fc951679de238cdcfc?entryPoint=141';

const ID_NON_LIVE_POST_LOGIN_PAGES = [
  'https://app-uat1.uat.seabank.co.id/app/me/account',
  'https://app-uat1.uat.seabank.co.id/app/me/email',
  'https://app-uat1.uat.seabank.co.id/app/me/personalDetails',
  'https://app-uat1.uat.seabank.co.id/app/payment/setting/linkedShopee',
  'https://app-uat1.uat.seabank.co.id/app/payment/setting',
  'https://app-uat1.uat.seabank.co.id/app/me/setting',
  'https://app-uat1.uat.seabank.co.id/app/shopee/linkage',
  'https://app-uat1.uat.seabank.co.id/app/home',
  'https://app-uat1.uat.seabank.co.id/app/transfer/home',
  'https://app-uat1.uat.seabank.co.id/app/qris/home',
  'https://app-uat1.uat.seabank.co.id/app/td/home',
  'https://app-uat1.uat.seabank.co.id/app/me/home',
];

const ID_LIVE_POST_LOGIN_PAGES = [
  'https://app.seabank.co.id/app/me/account',
  'https://app.seabank.co.id/app/me/email',
  'https://app.seabank.co.id/app/me/personalDetails',
  'https://app.seabank.co.id/app/payment/setting/linkedShopee',
  'https://app.seabank.co.id/app/payment/setting',
  'https://app.seabank.co.id/app/me/setting',
  'https://app.seabank.co.id/app/shopee/linkage',
  'https://app.seabank.co.id/app/home',
  'https://app.seabank.co.id/app/transfer/home',
  'https://app.seabank.co.id/app/qris/home',
  'https://app.seabank.co.id/app/td/home',
  'https://app.seabank.co.id/app/me/home',
];

const PH_NON_LIVE_LOGIN_PAGE = `https://app-uat1.uat.seabank.ph/app/me/chatbot?fromChatbot=true&${chatbotSkipFlag}`;
const PH_LIVE_LOGIN_PAGE = `https://app.seabank.ph/app/me/chatbot?fromChatbot=true&${chatbotSkipFlag}`;
const PH_NON_LIVE_WEBFORM
  = 'https://cs.uat.seabank.ph/portal/webform/5fa7631b774a45c5b3edd69376a7cfde?=entryPoint=2';
const PH_LIVE_WEBFORM = 'https://cs.seabank.ph/portal/webform/0bedff0667d94e518691b61cbc0760a1?=entryPoint=2';

const PH_NON_LIVE_POST_LOGIN_PAGES = [
  'https://app-uat1.uat.seabank.ph/app/me',
  'https://app-uat1.uat.seabank.ph/app/me/setting/account',
  'https://app-uat1.uat.seabank.ph/app/me/setting/general',
  'https://app-uat1.uat.seabank.ph/app/me/setting/notification',
  'https://app-uat1.uat.seabank.ph/app/me/setting/payment',
  'https://app-uat1.uat.seabank.ph/app/me/linkage/account',
  'https://app-uat1.uat.seabank.ph/app/deposit/accounts',
  'https://app-uat1.uat.seabank.ph/app/me/referral',
  'https://app-uat1.uat.seabank.ph/app/home',
  'https://app-uat1.uat.seabank.ph/app/me/profile',
  'https://app-uat1.uat.seabank.ph/app/ekyc/personalDetail',
  'https://app-uat1.uat.seabank.ph/app/deposit/addBalance',
  'https://app-uat1.uat.seabank.ph/app/me/bank/documents',
  'https://app-uat1.uat.seabank.ph/app/me/bc/list',
  'https://app-uat1.uat.seabank.ph/app/me/eStatement/list',
  'https://app-uat1.uat.seabank.ph/app/transaction/history/list',
  'https://app-uat1.uat.seabank.ph/app/card/delivery',
  'https://app-uat1.uat.seabank.ph/app/card',
  'https://app-uat1.uat.seabank.ph/app/card/setting',
  'https://app-uat1.uat.seabank.ph/app/card/setting/fee/list',
  'https://app-uat1.uat.seabank.ph/app/me/promos',
  'https://app-uat1.uat.seabank.ph/app/loan/enterHomepage?autoSimulate=true',
  'https://app-uat1.uat.seabank.ph/app/home/interestCalculator',
  'https://app-uat1.uat.seabank.ph/app/entryPoint/dp/bill',
  'https://app-uat1.uat.seabank.ph/app/dp/start?subCategory=Telco%20Pack',
  'https://app-uat1.uat.seabank.ph/app/qr/mine',
  'https://app-uat1.uat.seabank.ph/app/me/version',
  // 'https://m-uat1.uat.seabank.ph/contract/0002',
  'https://app-uat1.uat.seabank.ph/app/me/notification/ar/list',
  'https://app-uat1.uat.seabank.ph/app/card/setting/deactive/action?checkStatus=true',
  'https://app-uat1.uat.seabank.ph/app/card/setting/usage/action?checkStatus=true',
  'https://app-uat1.uat.seabank.ph/app/transaction/history/list?initialTypeGroupName=Card',
  'https://app-uat1.uat.seabank.ph/app/card/setting/limit?checkStatus=true',
  'shopeeph://main?apprl=/rn/@shopee-rn/shopeepay/HOME',
  'shopeeph://main?apprl=/n/ME',
  'https://app-uat1.uat.seabank.ph/app/home/interestCalculator',
  'https://app-uat1.uat.seabank.ph/app/entryPoint/dp/bill'
];

const PH_LIVE_POST_LOGIN_PAGES = [
  'https://app.seabank.ph/app/me',
  'https://app.seabank.ph/app/me/setting/account',
  'https://app.seabank.ph/app/me/setting/general',
  'https://app.seabank.ph/app/me/setting/notification',
  'https://app.seabank.ph/app/me/setting/payment',
  'https://app.seabank.ph/app/me/linkage/account',
  'https://app.seabank.ph/app/deposit/accounts',
  'https://app.seabank.ph/app/me/referral',
  'https://app.seabank.ph/app/home',
  'https://app.seabank.ph/app/me/profile',
  'https://app.seabank.ph/app/ekyc/personalDetail',
  'https://app.seabank.ph/app/deposit/addBalance',
  'https://app.seabank.ph/app/me/bank/documents',
  'https://app.seabank.ph/app/me/bc/list',
  'https://app.seabank.ph/app/me/eStatement/list',
  'https://app.seabank.ph/app/transaction/history/list',
  'https://app.seabank.ph/app/card/delivery',
  'https://app.seabank.ph/app/card',
  'https://app.seabank.ph/app/card/setting',
  'https://app.seabank.ph/app/card/setting/fee/list',
  'https://app.seabank.ph/app/me/promos',
  'https://app.seabank.ph/app/loan/enterHomepage?autoSimulate=true',
  'https://app.seabank.ph/app/home/interestCalculator',
  'https://app.seabank.ph/app/entryPoint/dp/bill',
  'https://app.seabank.ph/app/dp/start?subCategory=Telco%20Pack',
  'https://app.seabank.ph/app/qr/mine',
  'https://app.seabank.ph/app/me/version',
  // 'https://m.seabank.ph/contract/0002',
  'https://app.seabank.ph/app/me/notification/ar/list',
  'https://app.seabank.ph/app/card/setting/deactive/action?checkStatus=true',
  'https://app.seabank.ph/app/card/setting/usage/action?checkStatus=true',
  'https://app.seabank.ph/app/transaction/history/list?initialTypeGroupName=Card',
  'https://app.seabank.ph/app/card/setting/limit?checkStatus=true',
  'shopeeph://main?apprl=/rn/@shopee-rn/shopeepay/HOME',
  'shopeeph://main?apprl=/n/ME',
  'https://app.seabank.ph/app/home/interestCalculator',
  'https://app.seabank.ph/app/entryPoint/dp/bill'
];


const ENVIRONMENT_KEY = ENVIRONMENT === 'live' ? 'live' : 'nonLive';

const POST_LOGIN_PAGES = {
  id: {
    live: ID_LIVE_POST_LOGIN_PAGES,
    nonLive: ID_NON_LIVE_POST_LOGIN_PAGES,
  },
  ph: {
    live: PH_LIVE_POST_LOGIN_PAGES,
    nonLive: PH_NON_LIVE_POST_LOGIN_PAGES,
  },
}[COUNTRY]?.[ENVIRONMENT_KEY];

const REDIRECTION_PARAMS_NONLIVE = [
  {
    regexp: /^https:\/\/m\-uat1\.uat\.seabank\.ph\/contract\/0002/,
    extraParams: { navbar: { liveChatPageType: 'bank' } }
  }
];
const REDIRECTION_PARAMS_LIVE = [
  {
    regexp: /^https:\/\/m\.seabank\.ph\/contract\/0002/,
    extraParams: { navbar: { liveChatPageType: 'bank' } }
  }
];

const REDIRECTION_PARAMS = ENVIRONMENT_KEY === 'live' ? REDIRECTION_PARAMS_LIVE : REDIRECTION_PARAMS_NONLIVE

export function getFirstMatchParams(url: string | undefined) {
  if (!url) {
    return;
  }
  let matchedRule: (typeof REDIRECTION_PARAMS)[number] | null = null;
  REDIRECTION_PARAMS.some((rule) => {
    if (rule.regexp.test(url)) {
      matchedRule = rule
      return true;
    }
  });

  if (matchedRule) {
    return (matchedRule as (typeof REDIRECTION_PARAMS)[number])?.extraParams
  }
}

const LOGIN_PAGE = {
  id: {
    live: ID_LIVE_LOGIN_PAGE,
    nonLive: ID_NON_LIVE_LOGIN_PAGE,
  },
  ph: {
    live: PH_LIVE_LOGIN_PAGE,
    nonLive: PH_NON_LIVE_LOGIN_PAGE,
  },
}[COUNTRY]?.[ENVIRONMENT_KEY];

const WEBFORM = {
  id: {
    live: ID_LIVE_WEBFORM,
    nonLive: ID_NON_LIVE_WEBFORM,
  },
  ph: {
    live: PH_LIVE_WEBFORM,
    nonLive: PH_NON_LIVE_WEBFORM,
  },
}[COUNTRY]?.[ENVIRONMENT_KEY];

/**
 *
 * 判断bank url是否是需要登录的
 * @param {string} link - url
 * @returns
 */
export function isPostLoginPages(link: string) {
  if (link.includes(chatbotSkipFlag)) {
    return false;
  }

  // 排除shopeeth
  if (isAppScheme(link)) {
    return false;
  }

  return POST_LOGIN_PAGES?.some((page) => link?.startsWith(page));
}

function processNonLoginPageLink(link: string) {
  return `${link}${link.includes('?') ? '&' : '?'}${chatbotSkipFlag}`;
}

export function generateLoginCallbackParams(options: {
  method: BankUrlMethodParamEnum;
  methodData: Record<string, any> | string | undefined | null,
  methodIdName: string;
}) {
  const query: NonNullable<IBankLoginSceneParams> = {
    scene: BankUrlSceneParamEnum.fromLoginPage,
    method: options?.method,
    methodId: options?.methodData ? generateMethodId(options?.methodIdName) : undefined,
  };

  return {
    query,
    next: mergeQueryToUrl(window.location.href, query)
  };
}

export function generateUrlWithLoginCallbackUrl(options: {
  url: string;
  params: {
    liveChatForRecoverMessage: string;
  }
}) {
  return mergeQueryToUrl(options.url, {
    liveChatSessionId: initStore.sessionId,
    ...options.params
  });
}

export function jumpToLoginPage(options?: {
  actionData?: Record<string, any> | undefined | null
}) {
  const { query, next: loginCallbackUrl } = generateLoginCallbackParams({
    method: BankUrlMethodParamEnum.loginBtn,
    methodData: options?.actionData,
    methodIdName: BankUrlMethodParamEnum.loginBtn
  });
  if (options?.actionData && query.methodId) {
    saveMethodDataById(query.methodId, options.actionData);
  }
  LOGIN_PAGE && redirectionTo(generateUrlWithLoginCallbackUrl({
    url: LOGIN_PAGE,
    params: { liveChatForRecoverMessage: loginCallbackUrl }
  }));
}

export function addBankToLoginDialogue({
  dialogueId,
  dialogueType,
  link,
  callbackParams,
}: {
  dialogueId?: string;
  dialogueType?: string;
  link?: string;
  callbackParams?: ReturnType<typeof generateLoginCallbackParams>
}) {
  const transifyKeyMap = link
    ? {
      contentKey: 'chatbot_prelogin_appredirection_login_message',
      loginKey: 'chatbot_prelogin_appredirection_login_button',
    }
    : { contentKey: 'chatbot_prelogin_livechat_login_message', loginKey: 'chatbot_prelogin_livechat_login_button' };

  console.log('TODO:', 'addBankToLoginDialogue', 'callbackParams', {
    dialogueId,
    dialogueType,
    link,
    callbackParams
  });

  let mergedUrl: string | undefined = undefined;
  if (callbackParams) {
    const { query, next: loginCallbackUrl } = callbackParams;
    const targetUrl = link ? processNonLoginPageLink(link) : LOGIN_PAGE;
    if (targetUrl) {
      mergedUrl = generateUrlWithLoginCallbackUrl({
        url: targetUrl,
        params: { liveChatForRecoverMessage: loginCallbackUrl, }
      });
    }
  } else {
    const { query, next: loginCallbackUrl } = generateLoginCallbackParams({
      method: BankUrlMethodParamEnum.redirection,
      methodData: link,
      methodIdName: BankUrlMethodParamEnum.redirection,
    });
    const targetUrl = link ? processNonLoginPageLink(link) : LOGIN_PAGE;
    if (targetUrl) {
      mergedUrl = generateUrlWithLoginCallbackUrl({
        url: targetUrl,
        params: { liveChatForRecoverMessage: loginCallbackUrl, }
      });
    }

    console.log('TODO:', 'addBankToLoginDialogue', 'data', {
      methodId: query.methodId,
      methodData: link,
      mergedUrl
    });
    if (query?.methodId && link) {
      saveMethodDataById(query.methodId, { link });
    }
  }

  initStore.UPDATE_PINNED_ANNOUNCEMENT_DROPDOWN_OPEN(false);
  modalStore.UPDATE_MODAL_POP_UP_ANNOUNCEMENT_SHOW(false);

  const buttons: any[] = [
    {
      button_style: ButtonType.Primary,
      button_text: getTrans(transifyKeyMap.loginKey) || 'Login',
      action: {
        showUserMessage: false,
        action_type: ButtonAction.JumpURL,
        url_info: { url: mergedUrl },
        __tag__: {
          by: 'addBankToLoginDialogue'
        }
      },
      // onClick: () => {
      //   console.log('TODO:', 'addBankToLoginDialogue', 'data', {
      //     methodId: query.methodId,
      //     methodData: link
      //   });
      //   if (query?.methodId && link) {
      //     saveMethodDataById(query.methodId, {link});
      //   }
      // }
    }
  ];

  if (initStore.submitWebformSwitch) {
    buttons.push({
      button_style: ButtonType.PrimaryOutlined,
      button_text: getTrans('submit_webform') || 'Submit Online Form',
      action: {
        showUserMessage: false,
        action_type: ButtonAction.JumpFormstack,
        url_info: { url: WEBFORM },
      },
    })
  }

  addDialogue({
    dialogueId,
    dialogueType,
    from: 'bot',
    type: 'TFEMessage',
    data: {
      content:
        getTrans(transifyKeyMap.contentKey)
        || 'Please login to proceed with this request. Alternatively, you may submit an online form and we will get back to you shortly',
      buttonGroup: {
        layout: 'vertical',
        buttons: buttons
      },
    },
  });
}

const bankLoginEffectBridgeCallback = async (res: { data: string }) => {
  // console.log('bankLoginEffectBridgeCallback viewWillReappear, data=', {});
  clearBeforeRedirectToBankLoginEffect();
};
export function handleBeforeRedirectToBankLoginEffect() {
  // console.log('handleBeforeRedirectToBankLoginEffect, data=', {});
  bridgeCallFunc(() => {
    window.bridgeRegisterHandler('viewWillReappear', bankLoginEffectBridgeCallback);
  });
  saveRecoveryContext({ shouldUpdateCurrentUser: true }, { useCache: false });
}

export function clearBeforeRedirectToBankLoginEffect() {
  // console.log(' clearBeforeRedirectToBankLoginEffect viewWillReappear, data=');
  // 不能调用clearRecoveryData，经过测试页面卸载会触发viewWillReappear，可能与bank的destory页面栈有关的
  // clearRecoveryData()
  window.bridgeUnRegisterHandler('viewWillReappear', bankLoginEffectBridgeCallback);
}

export function isAppScheme(url: string) {
  try {
    const parsedUrl = parseUrlToObject(url);
    console.log("parsedUrl", parsedUrl)
    const scheme = parsedUrl.protocol.slice(0, -1); // 去掉末尾的冒号
    return scheme !== 'http' && scheme !== 'https';
  } catch (e) {
    return false; // 如果 URL 无效，返回 false
  }
}
